import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ValidationService } from '../../core/services/validation.service';
import { InvitationService } from '../services/invitation.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { CognitoService } from '../../core/services/cognito.service';
import { AuthService } from '../../core/auth/services/auth.service';
import { TranslateService } from '@ngx-translate/core';
import { Languages } from '../../core';
import { MatSnackBar } from '@angular/material/snack-bar';
@Component({
    selector: 'sign-up-component',
    templateUrl: './sign-up.component.html',
    styleUrls: ['./sign-up.component.scss'],
})
export class SignUpComponent implements OnInit {
    step = 'sign-up';
    user: any;
    username: string | null = null;
    showPassword: boolean = false;
    signUpForm = new FormGroup({
        email: new FormControl('', { validators: [this.validationService.email] }),
        password: new FormControl('', { validators: [this.validationService.password] }),
    });

    constructor(
        private activeRoute: ActivatedRoute,
        private validationService: ValidationService,
        private invitationService: InvitationService,
        private ngxService: NgxUiLoaderService,
        private cognitoService: CognitoService,
        private authService: AuthService,
        private translateService: TranslateService,
        private router: Router,
        private _snackBar: MatSnackBar,
    ) {}

    get emailCtrl(): FormControl {
        return this.signUpForm.get('email') as FormControl;
    }

    get passwordCtrl(): FormControl {
        return this.signUpForm.get('password') as FormControl;
    }

    ngOnInit() {
        this.activeRoute.params.subscribe(params => {
            this.ngxService.start();
            //url encode prams
            this.username = params.username;
            this.invitationService.getUser(this.username ?? '').subscribe(
                result => {
                    this.ngxService.stop();
                    if (result.data) {
                        if (result.data.status.value === 'CONFIRMED') {
                            this.router.navigate(['/login']);
                            this._snackBar.open(this.translateService.instant('User.AlreadyConfirmed'), 'x', {
                                horizontalPosition: 'right',
                                panelClass: ['notif-error'],
                                verticalPosition: 'top',
                                duration: 3000,
                            });
                            return;
                        }
                        this.user = result.data;
                        this.emailCtrl.patchValue(this.user.email);
                        const defaultLang =
                            this.user.languages.includes(Languages.EN) && this.user.languages.includes(Languages.HE)
                                ? Languages.EN
                                : this.user.languages[0];
                        this.translateService.setDefaultLang(defaultLang);
                    } else {
                        if (result.errorCode === 'NotFoundUser') {
                            this.router.navigate(['/login']);
                            this._snackBar.open(this.translateService.instant('User.NotFound'), 'x', {
                                horizontalPosition: 'right',
                                panelClass: ['notif-error'],
                                verticalPosition: 'top',
                                duration: 3000,
                            });
                        } else {
                            this.router.navigate(['/login']);
                            this._snackBar.open(this.translateService.instant('User.GetUserFail'), 'x', {
                                horizontalPosition: 'right',
                                panelClass: ['notif-error'],
                                verticalPosition: 'top',
                                duration: 3000,
                            });
                        }
                    }
                },
                error => {
                    this.ngxService.stop();
                    console.error(error);
                },
            );
        });
    }

    onSignup(): void {
        if (this.signUpForm.invalid) {
            this.signUpForm.markAllAsTouched();
            return;
        }
        if (this.signUpForm.valid) {
            this.ngxService.start();
            const password = this.passwordCtrl.value;
            const request = {
                username: this.username!,
                password,
            };
            this.invitationService.confirmUser(request).subscribe(
                result => {
                    if (result?.status) {
                        this.cognitoService
                            .signIn({ email: this.emailCtrl.value, password: this.passwordCtrl.value })
                            .then(dataSignIn => {
                                const accessToken = dataSignIn?.signInUserSession?.accessToken?.jwtToken;
                                const idToken = dataSignIn?.signInUserSession?.idToken?.jwtToken;
                                if (accessToken && idToken) {
                                    this.authService.onAuthentication(accessToken, idToken);
                                    this.step = 'sign-up-profile';
                                }
                            })
                            .finally(() => {
                                this.ngxService.stop();
                            });
                    } else {
                        this.ngxService.stop();
                    }
                },
                () => {
                    this.ngxService.stop();
                },
            );
        }
    }

    public togglePasswordVisibility(): void {
        this.showPassword = !this.showPassword;
    }

    validatorEmail: any = (c: any) => {
        return this.validationService.email(c);
    };

    validatorPassword: any = (c: any) => {
        return this.validationService.password(c);
    };
}
